var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuickToSetupHorizontalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1366 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 73.627l-.04-.999.04 1zM-78.362 2.56C-9.629 29.252 167.849 81.034 328.04 74.627l-.08-1.999C168.151 79.021-9.038 27.336-77.638.695l-.724 1.865zM328.04 74.627c50.055-2.003 99.098-8.384 148.103-15.479 49.019-7.096 97.984-14.903 147.954-19.775 99.911-9.742 203.746-7.737 319.555 35.192l.696-1.875C828.157 29.62 723.992 27.623 623.903 37.382c-50.03 4.878-99.065 12.696-148.046 19.787-48.995 7.093-97.952 13.461-147.897 15.46l.08 1.998zm615.612-.062c116.038 43.014 216.118 70.541 299.728 81.055 83.59 10.511 150.82 4.027 201.07-21.098l-.9-1.789c-49.75 24.875-116.52 31.39-199.93 20.902-83.39-10.486-183.31-37.959-299.272-80.945l-.696 1.875z",
    fill: "#0C0A0C"
  })));
}

export default SvgQuickToSetupHorizontalLine;